import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { getSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import {
	autoEuropeCheckersTableData,
	autoEuropeCheckersTableIsLoading,
} from "Pages/AutoEuropeTool/Checkers/@signals"

const TABLE_CHECKERS_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/table-checkers`

export default function useAutoEuropeCheckersTable() {
	const { showToast } = useToast()

	const getTableData = useCallback(() => {
		batch(() => {
			autoEuropeCheckersTableIsLoading.value = true
			autoEuropeCheckersTableData.value = []
		})
		getSubmit(TABLE_CHECKERS_API)
			.then(data => {
				batch(() => {
					autoEuropeCheckersTableData.value = data ?? []
					autoEuropeCheckersTableIsLoading.value = false
				})
			})
			.catch(() => {
				autoEuropeCheckersTableIsLoading.value = false
				showToast.error("Error loading checkers")
			})
	}, [])

	return { getTableData }
}